
import { Injectable } from '@angular/core';
import { AbstractFormActionHandler } from '../abstract-form-action-handler';
import { FormService } from '../../../form.service';
import { HandlePhoneCountryCodeContactPersonActionHandler } from './handle-phone-country-code-contact-person-action-handler';

@Injectable()
export class HandleSecondaryPhoneCountryCodeContactPersonActionHandler extends HandlePhoneCountryCodeContactPersonActionHandler {

    protected getPhoneCountryCodeDatamodelField(): string {
        return 'secondaryPhoneCountryCode';
    }

    protected getPhoneAreaCodeDatamodelField(): string {
        return 'secondaryPhoneAreaCode';
    }

    protected getPhoneNumberDatamodelField(): string {
        return 'secondaryPhoneNumber';
    }
}
